module.exports = __webpack_public_path__ + "img/biaoqian_jiayouzhan.9ca55ae1.png";